(() => {
  function setupCollectionsPanel() {
    const header = document.querySelector("[data-header-wrapper]");
    const triggerItem = document.querySelector("[data-collections-trigger]");
    const panel = document.querySelector("[data-collections-panel]");
    if (!header || !triggerItem || !panel) return;

    const openClass = "header__collections-panel--open";

    const setOffset = () => {
      const h = header.getBoundingClientRect().height || 80;
      document.documentElement.style.setProperty("--header-offset", `${Math.round(h)}px`);
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!panel.classList.contains(openClass)) return;
        close();
      },
      { passive: true },
    );

    const open = () => {
      setOffset();
      // The panel stays hidden until it first opens, so its images only load for people who open it.
      if (panel.hidden) {
        panel.hidden = false;
        panel.getBoundingClientRect(); // start the fade from opacity 0
      }
      panel.classList.add(openClass);
      panel.setAttribute("aria-hidden", "false");
    };

    const close = () => {
      panel.classList.remove(openClass);
      panel.setAttribute("aria-hidden", "true");
    };

    const isGoingTo = (e, el) => !!(el && e.relatedTarget && el.contains(e.relatedTarget));

    const hoverState = { trigger: false, panel: false };

    const isHoveringMenu = () => hoverState.trigger || hoverState.panel;

    if (panel.dataset.bound === "1") return;
    panel.dataset.bound = "1";

    triggerItem.addEventListener("pointerenter", () => {
      hoverState.trigger = true;
      open();
    });

    triggerItem.addEventListener("pointerleave", (e) => {
      hoverState.trigger = false;
      if (isGoingTo(e, panel)) return;
      if (!isHoveringMenu()) close();
    });

    panel.addEventListener("pointerenter", () => {
      hoverState.panel = true;
      open();
    });

    panel.addEventListener("pointerleave", (e) => {
      hoverState.panel = false;
      if (isGoingTo(e, triggerItem)) return;
      if (!isHoveringMenu()) close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    document.addEventListener("click", (e) => {
      if (!panel.classList.contains(openClass)) return;
      const insidePanel = panel.contains(e.target);
      const insideTrigger = triggerItem.contains(e.target);
      if (!insidePanel && !insideTrigger) close();
    });

    let scrollCloseRAF = null;
    window.addEventListener(
      "scroll",
      () => {
        if (!panel.classList.contains(openClass)) return;

        if (isHoveringMenu()) return;

        if (scrollCloseRAF) cancelAnimationFrame(scrollCloseRAF);
        scrollCloseRAF = requestAnimationFrame(() => {
          if (!isHoveringMenu()) close();
        });
      },
      { passive: true },
    );

    window.addEventListener("resize", () => {
      if (panel.classList.contains(openClass)) setOffset();
    });

    setOffset();
  }

  document.addEventListener("DOMContentLoaded", setupCollectionsPanel);
  document.addEventListener("shopify:section:load", setupCollectionsPanel);
})();
